document.querySelectorAll(".element-resources [data-expand-anchor]").forEach((el) => {
  const shouldExpand = el.dataset.expandAnchor === window.location.hash.substring(1);

  if (!shouldExpand) {
    return;
  }

  el.querySelector("[data-slide-toggle]").click();
});
